import { faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Card } from 'flowbite-react';
import { useEffect, useState } from 'react';

import { FaIconLite } from 'src/components/fa-icon-lite';

const LoadingScreen = () => {
  const [loadingStage, setLoadingStage] = useState(0);

  useEffect(() => {
    if (loadingStage >= 2) return;
    const interval = setInterval(() => {
      setLoadingStage((prevStage) => (prevStage < 2 ? prevStage + 1 : prevStage));
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [loadingStage]);
  return (
    <Card className='p-8 text-center'>
      <h2 className='mb-3 text-xl font-semibold'>Generating Your Email Content</h2>
      <p className='text-gray-600'>
        Your subjects and previews are generating! Please wait a few seconds. It should be ready soon!
      </p>
      <ul className='max-w-md list-inside space-y-2 text-left text-gray-500 dark:text-gray-400'>
        {loadingStage > 0 ? (
          <LoadingScreenGreenCheck text='Analyzing your email screenshot' />
        ) : (
          <LoadingScreenWithSpinner text='Analyzing your email screenshot' />
        )}
        {loadingStage > 0 ? (
          loadingStage > 1 ? (
            <LoadingScreenGreenCheck text='Extracting insights from your store url' />
          ) : (
            <LoadingScreenWithSpinner text='Extracting insights from your store url' />
          )
        ) : (
          <LoadingScreenGray text='Extracting insights from your store url' />
        )}
        {loadingStage == 2 ? (
          <LoadingScreenWithSpinner text='Generating subject lines and previews' />
        ) : (
          <LoadingScreenGray text='Generating subject lines and previews' />
        )}
      </ul>
    </Card>
  );
};

interface LoadingScreenListItemProps {
  text: string;
}
const LoadingScreenWithSpinner = ({ text }: LoadingScreenListItemProps) => {
  return (
    <li className='flex items-center'>
      <div role='status'>
        <FaIconLite icon={faSpinner} spin className='me-2 size-4 text-blue-600' />
        <span className='sr-only'>Loading...</span>
      </div>
      {text}
    </li>
  );
};

const LoadingScreenGreenCheck = ({ text }: LoadingScreenListItemProps) => {
  return (
    <li className='flex items-center'>
      <FaIconLite icon={faCheckCircle} className='me-2 size-4 text-green-500' />
      {text}
    </li>
  );
};

const LoadingScreenGray = ({ text }: LoadingScreenListItemProps) => {
  return (
    <li className='flex items-center text-gray-50'>
      <span className='text-gray-300'>{text}</span>
    </li>
  );
};

export default LoadingScreen;
